import {i18n} from '@netx/core-locales';

export let types = {
	asset: 'asset',
	attributeSet: 'attributeSet',
	cart: 'cart',
	savedCart: 'savedCart',
	category: 'category',
	constituent: 'constituent',
	//search: 'search'
	savedSearch: 'savedSearch',
	// NOTE: this got changed to 'assets' but these are not strings to i18n, these are DAM symbols. Use i18n.asssetSet or similar instead.
	assetSet: 'assetSet',
};

export let organizeByTypes = {
	none: {
		value: 0,
		label: i18n.t('i18n.noOrganization'),
	},
	fileType: {
		value: -105,
		label: i18n.t('i18n.fileType'),
	},
	fileFormatFamily: {
		value: -106,
		label: i18n.t('i18n.fileFormatFamily'),
	},
	folderPath: {
		value: -108,
		label: i18n.t('i18n.categoryPath'),
	},
};

export default {organizeByTypes, types};
